/* KURO — the add button, pinned
 *
 * On a phone the add button sits about 1,000px down the product page: below
 * the first image, the title, the price, the 品番, the colour and the sizes.
 * A reader who has decided has to scroll back to it, and a reader who scrolls
 * past it into the description has nothing to press. So the same button is
 * pinned to the bottom of the screen while the real one is out of sight, and
 * taken away the moment the real one is back.
 *
 * An IntersectionObserver rather than a scroll handler: the question is
 * literally "is that element on screen", the browser answers it off the main
 * thread, and there is no arithmetic here to get wrong on a zoomed page or a
 * short viewport.
 *
 * The root is shortened by 56px at the bottom — the height of the bar — so
 * that the real button counts as out of sight while the bar is standing over
 * it. Without that the two would trade places along a single line and the bar
 * would flicker as the button crossed it.
 *
 * Phones only, and only while there is something to add: a pinned SOLD OUT
 * would take 56px of every screen to say a thing the page has already said.
 */
(function () {
  'use strict';

  var MOBILE = '(max-width: 767px)';
  var BAR_HEIGHT = 56;

  var mq = window.matchMedia(MOBILE);
  var observer = null;
  var bar = null;
  var button = null;
  var buttonOnScreen = true;

  function paint() {
    if (!bar) return;
    bar.hidden = !mq.matches || buttonOnScreen;
  }

  function watch() {
    if (observer || !button) return;
    observer = new IntersectionObserver(
      function (entries) {
        buttonOnScreen = entries[0].isIntersecting;
        paint();
      },
      { rootMargin: '0px 0px -' + BAR_HEIGHT + 'px 0px' }
    );
    observer.observe(button);
  }

  function unwatch() {
    if (observer) {
      observer.disconnect();
      observer = null;
    }
    buttonOnScreen = true;
    paint();
  }

  function init() {
    unwatch();

    bar = document.querySelector('[data-kuro-sticky-add]');
    button = document.querySelector('.kuro-y-pdp__form .kuro-y-add');

    /* Nothing to pin, or nothing to add. Either way the bar stays away — it
       is written hidden, so this is a no-op rather than a cleanup. */
    if (!bar || !button || button.disabled) {
      bar = null;
      button = null;
      return;
    }

    if (mq.matches) watch();
    else paint();
  }

  init();

  /* The theme editor re-renders a section in place, which replaces both the
     bar and the button the observer was holding. Re-read them. */
  document.addEventListener('shopify:section:load', init);

  mq.addEventListener('change', function () {
    if (mq.matches) watch();
    else unwatch();
  });
}());
